import {
  TemplateResponseData,
  Template,
  TemplatePreviewList,
  TemplateSearchData,
  LIHPTemplate,
  TemplateDimension,
} from '@invideoio/web-shared/types/Templates';

const _processTemplatesResponse = (
  templates: TemplateResponseData[],
): Template[] =>
  templates.map(template => ({
    ...template,
    preview_list: JSON.parse(template.preview_list) as TemplatePreviewList,
  }));

export const processTemplateSearchAPIResponse = (
  response: any,
): TemplateSearchData => ({
  ...response,
  templates: _processTemplatesResponse(response.templates ?? []),
});

export const getLihpTemplates = (templates: Template[]): LIHPTemplate[] => {
  return templates.map(template => {
    let lihpTemplate = {
      id: template.id,
      name: template.name,
      previewURL: template.preview_url,
      thumbnailURL: template.thumbnail_url,
      templateURL: `/workflow/marketing-templates/${template.id}`,
      dimension: template.dimension,
      dimensions: template.dimensions,
      isFavouriteTemplate: template.is_favourite_template,
      creatorName: template.creator_name,
      tutorialLink: template.tutorial_link,
      preview_list: template.preview_list,
      template_type: template.template_type,
      creator_id: template.creator_id,
      creator_name: `${template.creator.first_name || ''} ${
        template.creator.last_name || ''
      }`,
      workflow: template.workflow,
      creator: template.creator,
      isNew: isTemplateNew(template.created_at),
      categories: template.categories0,
      industries: template.industries,
      algoliaObjectId: template.algoliaObjectId,
    };
    if (!template.preview_url || !template.thumbnail_url) {
      lihpTemplate = {
        ...lihpTemplate,
        // TODO: improve handling
        previewURL: template.preview_list.story?.default?.preview_url ?? '',
        thumbnailURL: template.preview_list.story?.default?.thumbnail_url ?? '',
      };
    }
    return lihpTemplate;
  });
};

export const buildCategoryTree = (categoryList: any[]) => {
  const categoryTree: Record<string, any> = {};

  categoryList.forEach(category => {
    const isCategoryExists = categoryTree[category.CategoryType];

    if (isCategoryExists) {
      categoryTree[category.CategoryType] = [
        ...categoryTree[category.CategoryType],
        category,
      ];
    } else {
      categoryTree[category.CategoryType] = [category];
    }
  });

  return categoryTree;
};

export const isTemplateNew = (createdAt: string) => {
  const createdDate = new Date(createdAt);
  const today = new Date();

  const timeDifference = today.getTime() - createdDate.getTime();
  let daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));
  return daysDifference < 20;
};

export const isQuickVideo = (workflow: string) => {
  return workflow === 'marketing' || workflow === '';
};

export const getUrlToCopyFromTemplateId = (templateId: number): string => {
  const base = `${window.location.origin}`;
  return base + '/workflow/marketing-templates/' + templateId;
};

export const copyTemplateUrlToClipboard = (urlToCopy: string) => {
  const copyDummy = document.createElement('input');
  copyDummy.value = urlToCopy;
  document.body.appendChild(copyDummy);
  copyDummy.select();
  document.execCommand('copy');
  document.body.removeChild(copyDummy);
};

export const getTemplatePreviewHeight = (
  showRelatedTemplates: boolean = false,
  previewHeight = 600,
) => {
  return showRelatedTemplates ? previewHeight - 80 : previewHeight;
};

export const getTemplatePreviewUrlForDimension = (
  template: LIHPTemplate,
  selectedDimension: TemplateDimension,
) => {
  if (selectedDimension === template.dimension) {
    return template.previewURL;
  } else {
    const templatePreviewList: any = template?.preview_list;
    if (templatePreviewList?.[template?.template_type]) {
      return templatePreviewList?.[template?.template_type]?.[selectedDimension]
        ?.preview_url;
    } else if (templatePreviewList?.['story']?.[selectedDimension]) {
      return templatePreviewList?.['story']?.[selectedDimension]?.preview_url;
    }
    return template.previewURL;
  }
};
